export default __webpack_public_path__ + "static/media/etc_banner_1920x504.59706d0a.jpg";